
import { RootStoreModel } from "@stores/RootStore";
import { WorkspaceModelType } from "@stores/WorkspaceStore";

export const showInWorkspace = (
    rootStore: RootStoreModel,
    itemId: string,
    workspace: WorkspaceModelType,
    parentId?: string
) => {
    const itemMST = workspace.items.get(itemId);
    if (!itemMST) {
        return;
    }
    workspace.setScrollIntoViewId(itemMST.id);
    const parentPaths = itemMST.getParentPaths();

    if (parentPaths.length > 0) {
        const first_path = parentId ? parentPaths.find(parentPath => parentPath.includes(parentId)) || parentPaths[0] : parentPaths[0];
        for (const parentId of first_path) {
            const parentItem = workspace.items.get(parentId)!;
            parentItem.setExpanded(true);
        }
    }

    rootStore.search.setTextInput('');
}